import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { HeaderV3 } from "ComponentsUI/Header";

const useStyles = createUseStyles((theme) => ({
	root: {
		position: "static",
		marginBottom: "30px",
	},
	borderBGText: {
		padding: "20px",
		backgroundColor: theme.palette.colors.white,
		border: `solid 1px ${theme.palette.colors.disabled}`,
		borderRadius: "20px",
	},
	text: {
		fontFamily: theme.fonts.light,
		fontSize: "18px",
		lineHeight: "21px",
		color: theme.palette.colors.darkSlateBlue,
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		text: {
			lineHeight: "20px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		text: {
			lineHeight: "20px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		text: {
			fontSize: "14px",
			lineHeight: "16зч",
		},
	},
}));

const HeaderTextSeo = (props) => {
	const { header, text, hideTitle, bgText, className } = props;
	let classes = useStyles();

	return (
		<div className={classNames(classes.root, className)}>
			{!hideTitle && !!header && <HeaderV3 header={header} />}
			{text && (
				<div
					className={classNames(classes.text, {
						[classes.borderBGText]: bgText,
					})}
					dangerouslySetInnerHTML={{
						__html: text,
					}}
				/>
			)}
		</div>
	);
};

HeaderTextSeo.defaultProps = {
	bgText: false,
	hideTitle: false,
	header: "",
	text: "",
};

HeaderTextSeo.propTypes = {
	header: PropTypes.string.isRequired,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
	bgText: PropTypes.bool,
	hideTitle: PropTypes.bool,
};

export default HeaderTextSeo;
